/**
 * Created by michaelbray on 5/4/18.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

const propTypes = {
    title: PropTypes.string,
    url: PropTypes.string,
    description: PropTypes.string,
    openGraphCard: PropTypes.string,
    twitterCard: PropTypes.string
};

const defaultProps = {
    title: "Recreation.gov - Bring Home a Story",
    url: "https://www.recreation.gov",
    description: "Recreation.gov is your source for discovering and experiencing America's federal recreation activities and outdoor adventures.\"",
    openGraphCard: "https://beta.recreation.gov/FacebookOG.png",
    twitterCard: "https://beta.recreation.gov/TwitterCard.png"
};

export default class HelmetWrapper extends React.Component {
    render() {
        return (
            // Todo - Mike Bray: Confirm format of titleTemplate
            <Helmet titleTemplate="Recreation.gov - %s" defaultTitle="Recreation.gov - Bring Home a Story">
                <title tabIndex="-1">{this.props.title}</title>
                <meta name="description" content={this.props.description} />

                <meta property="og:title" content={this.props.title} />
                <meta property="og:url" content={this.props.url} />
                <meta property="og:description" content={this.props.description} />
                <meta property="og:image" content={this.props.openGraphCard} />

                <meta name="twitter:title" value={this.props.title} />
                <meta name="twitter:url" value={this.props.url} />
                <meta name="twitter:description" value={this.props.description} />
                <meta name="twitter:image" content={this.props.twitterCard} />
            </Helmet>
        );
    }
}

HelmetWrapper.propTypes = propTypes;
HelmetWrapper.defaultProps = defaultProps;
